"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserPreferencesRequestTypes = void 0;
/**
 * User Preferences Request Type
 */
var UserPreferencesRequestTypes;
(function (UserPreferencesRequestTypes) {
    UserPreferencesRequestTypes["CURRENCY"] = "currency";
    UserPreferencesRequestTypes["CHAIN_PRIORITY"] = "chain_priority";
    UserPreferencesRequestTypes["CHAIN_PROPERTIES"] = "chain_properties";
    UserPreferencesRequestTypes["WALLET_ORDER"] = "wallet_order";
})(UserPreferencesRequestTypes || (exports.UserPreferencesRequestTypes = UserPreferencesRequestTypes = {}));
